import UptimeBob from "@/assets/images/uptime-bob.svg";
import {OnboardingWizardStep} from "@/lib/types/accounts.ts";

import {StepContent} from "../step/Step";
import {StepWelcomeBody} from "./StepWelcomeBody";

export const STEP_WELCOME: StepContent = {
  name: OnboardingWizardStep.WELCOME,
  title: "Welcome to Uptime, %name%",
  subtitle: "Tell us how you’d like to use Uptime",
  iconURL: UptimeBob,
  iconPosition: "top",
  body: StepWelcomeBody,
};
